import { useCallback, useState } from 'react';
import { useQuery } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { ALL_OPTION_KEY } from '@/common/constants';
import { API_URL } from '@/dtos';

import { useDownloadCSV, useGetEmployerIdParam } from '../../hooks';
import { EmployeeDemographicsReportTableParams } from '../EmployeeDemographicsReport.types';

export const QUERY_KEY = 'EXPORT_DEMOGRAPHIC_ACCOUNT_ACTIVITY_REPORT_CSV';
const useEmployeeDemographicReportExportCSVQuery = (params: EmployeeDemographicsReportTableParams) => {
  const handleSaveFile = useDownloadCSV();
  const [isLoading, setIsLoading] = useState(false);
  const getEmployerIdParam = useGetEmployerIdParam();
  const { isSuccess, refetch } = useQuery(
    [QUERY_KEY],
    () =>
      api.get(API_URL.REPORTS_EMPLOYEE_DEMOGRAPHICS_REPORT_BREAKDOWN_EXPORT_CSV, {
        params: _.pickBy({
          show_ssn: params.isSSNShowed,
          employment_statuses:
            params.employmentStatuses && !params.employmentStatuses.includes(ALL_OPTION_KEY)
              ? params.employmentStatuses.join(',')
              : undefined,
          search_value: params.searchString,
          ...getEmployerIdParam(params.employerId, params.employerIds),
        }),
      }),
    {
      retry: 0,
      enabled: false,
    }
  );

  const handleExport = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await refetch();
      handleSaveFile(response.data?.data, 'csv', 'employee-demographic-report');
    } finally {
      setIsLoading(false);
    }
  }, [handleSaveFile, refetch]);
  return {
    isLoading,
    isSuccess,
    handleExport,
  };
};

export default useEmployeeDemographicReportExportCSVQuery;
